<script lang="ts">
  import { tStore } from '../i18n'
  import { pendingLeaveConfirm, confirmLeave, cancelLeave } from '../stores/unsavedChanges'
</script>

{#if $pendingLeaveConfirm}
  <!-- svelte-ignore a11y_click_events_have_key_events a11y_no_static_element_interactions -->
  <div class="dialog-backdrop" onclick={cancelLeave}>
    <div
      class="dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="unsaved-changes-title"
      tabindex="-1"
      onclick={(e) => e.stopPropagation()}
    >
      <h3 id="unsaved-changes-title">{$tStore('components.unsavedChangesModal.title')}</h3>
      <p class="dialog__body">{$tStore('components.unsavedChangesModal.body')}</p>
      <div class="dialog__actions">
        <button type="button" class="btn btn--secondary" onclick={cancelLeave}>
          {$tStore('components.unsavedChangesModal.stay')}
        </button>
        <button type="button" class="btn btn--danger" onclick={confirmLeave}>
          {$tStore('components.unsavedChangesModal.leave')}
        </button>
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  @use '../assets/styles/variables' as v;

  .dialog-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1100;
  }

  .dialog {
    background: v.$color-surface-elevated;
    border: 1px solid v.$color-border;
    border-radius: v.$radius-lg;
    box-shadow: v.$shadow-lg;
    padding: v.$space-lg;
    max-width: 28rem;
    width: calc(100% - 2rem);

    h3 {
      margin: 0 0 v.$space-sm;
      font-size: 1.125rem;
    }
  }

  .dialog__body {
    color: v.$color-text-muted;
    margin: 0 0 v.$space-lg;
  }

  .dialog__actions {
    display: flex;
    justify-content: flex-end;
    gap: v.$space-sm;
  }
</style>
